import React, {
  useState,
  useCallback,
  useEffect,
  ChangeEvent,
  ChangeEventHandler,
} from "react";
import { Button, Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSearch } from "@fortawesome/free-solid-svg-icons";
import Grid, { getColumns } from "../../../shared-components/Grid/Grid";

import noMessageIcon from "../../../assets/Images/svg/018-empty.svg";
import { FormattedMessage } from "react-intl";

import { demoStoreData } from "../../../core/stores/data";
import IPageInfo, { IPageLimitInfo } from "../../../models/ICommon";
import { useStore } from "../../../contexts/store-provider";
import userSettingEnum from "../../../constants/enums/user-setting-enum";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";
import AddPopupHOC from "../../../shared-components/popup/add/add-popup-hoc";
import ShowPopupHOC from "../../../shared-components/popup/show/show-popup-hoc";
import DeletePopupHOC from "../../../shared-components/popup/delete/delete-popup-hoc";
import Pagination from "../../../shared-components/Grid/Pagination";
import { observer } from "mobx-react";
import DeletePopup from "../../../shared-components/popup/delete/delete-popup";
import AddStoreManagement from "./components/add-edit-store";
import demoStoreIcon from "../../../assets/Images/man.png";
import NoImage from "../../../assets/Images/no_image_available.jpg";
import LoaderButton from "../../../shared-components/button/loader-button";
import { IUpdateStoreManagement } from "../../../models/forms/IAddStore";
import { ISorting } from "../../../models/ISorting";
import { ColumnType } from "../../../constants/enums/grid-column-type-enum";
import { IStoreManagementList } from "../../../models/response/IStoreManagementResponse";
import { CellContext } from "@tanstack/react-table";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import DropdownInput from "../../../shared-components/input/DropdownInput";
import {
  staffInitialFilterState,
  storeInitialFilterState,
} from "../../../core/initialState/initial-filter-state";
import ChangePassword from "../../user/components/change-password";
import ChangePasswordPopupHOC from "../../../shared-components/popup/change-password/change-password-popup-hoc";
import { useHistory, useLocation } from "react-router-dom";
import RoutesConstants from "../../../shared-components/routes/routes-constants";
import LanguageSlider from "../../../shared-components/language-slider/language-slider";
import { ModuleType } from "../../../constants/enums/module-type-enum";
import { isOperationPermittedRoleBase } from "../../../helpers/action-permission-helper";
import { ActionType } from "../../../constants/enums/action-type-enum";
import { findRouteAccess } from "../../../helpers/route-helper";
import {
  getBusinessTypeIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../../helpers/localstorage-helper";
import userTypeEnum from "../../../constants/enums/user-type-enum";
import base64 from "base-64";
import { IUpdateStorePassword } from "../../../models/forms/IChangePassword";
import { safeBase64Encode } from "../../../constants/constants";
import "./store-list.css";

const StoreList: React.FC = (props: any) => {
  const {
    storeManagementStore,
    preferencesStore,
    masterManagementStore,
    userStore,
  } = useStore();
  const [openPanel, setOpenPanel] = useState(false);
  const {
    inProgress,
    GetStoreManagementListService,
    GetStoreManagementFreewordFilterService,
    allStoreManagement,
    storeList,
    resetAddUpdateStoreManagementState,
    addUpdateStoreManagementState,
    deleteStoreManagementState,
    resetDeleteStoreManagement,
    setStoreFilterDetail,
    getStoreFilter,
    resetStoreFilterDetail,
  } = storeManagementStore;
  const { UpdatePasswordService } = userStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    GetAllBusinessTypeService,
    getAllBusinessTypesAll,
    GetReservationSettingByIdService,
  } = masterManagementStore;
  const [storeNameSearch, setStoreNameSearch] = useState("");
  const [prefectureNameSearch, setPrefectureNameSearch] = useState("");
  const [prefectureSearch, setPrefectureSearch] = useState("");
  const [businessTypeSearch, setBusinessTypeSearch] = useState(
    getStoreFilter.BusinessTypeId ?? -1
  );
  const [searchText, setSearchText] = useState("");
  const [showInvalidStores, setShowInvalidStores] = useState(
    storeInitialFilterState.IsInvalid ?? false
  );

  const handleBusinessTypeSearch: ChangeEventHandler<HTMLSelectElement> =
    useCallback((event: ChangeEvent<HTMLSelectElement>) => {
      setBusinessTypeSearch(event.target.value as unknown as number);
      setSearchText("");
      setStoreNameSearch("");
      setStoreFilterDetail({
        ...getStoreFilter,
        IsFilterActive: true,
        BusinessTypeId: event.target.value as unknown as number,
      });
      setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
    }, []);

  const handleStoreNameSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setStoreNameSearch(e.target.value);
    },
    []
  );

  const handleInvalidStaffFilter = useCallback(() => {
    setSearchText("");
    setStoreNameSearch("");
    setShowInvalidStores((prev) => {
      setStoreFilterDetail({
        ...getStoreFilter,
        IsFilterActive: true,
        IsInvalid: !prev,
      });
      return !prev;
    });
    setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
  }, [getStoreFilter, setStoreFilterDetail]);

  const handlePrefectureNameSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPrefectureNameSearch(e.target.value);
    },
    []
  );

  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedStoreCode, setSelectedStoreCode] = useState<string>("");
  const pageLimitOptions: Array<number> = [10, 50, 100];
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const [sorting, setSorting] = useState<ISorting>({
    column: "store_name",
    orderBy: "asc",
  });

  const [modalShow, setModalShow] = useState(false);
  const [detailsModalShow, setDetailsModalShow] = useState(false);
  const [editingStore, setEditingStore] = useState<
    IUpdateStoreManagement | undefined
  >(undefined);

  const userType = getUserTypeFromLocalStorage();
  const businessTypeId = getBusinessTypeIdFromLocalStorage();

  const handleSeeDetails = useCallback((store: IUpdateStoreManagement) => {
    setEditingStore(store);
    setDetailsModalShow(true);
  }, []);

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pageInfo.totalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const handleSortingChange = (accessor: string) => {
    let sortOrder = sorting.orderBy;
    if (accessor === sorting.column) {
      sortOrder = sorting.orderBy === "asc" ? "desc" : "asc";
    }
    setSorting({ column: accessor, orderBy: sortOrder });
  };

  /**
   * This function calls the "getAllGroup" store funtion that get configuration list from API
   */
  const callGetStoreManagementListService = useCallback(() => {
    if (searchText) {
      GetStoreManagementFreewordFilterService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        searchText
      );
    } else {
      GetStoreManagementListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        sorting.column,
        sorting.orderBy,
        {
          BusinessTypeId: businessTypeSearch,
          StoreName: searchText,
          PrefectureName: prefectureSearch,
          IsInvalid: showInvalidStores,
        }
      );
    }
  }, [
    searchText,
    GetStoreManagementFreewordFilterService,
    pageInfo.currentPage,
    pageLimitInfo.pageLimit,
    GetStoreManagementListService,
    sorting.column,
    sorting.orderBy,
    businessTypeSearch,
    prefectureSearch,
    showInvalidStores,
  ]);

  useEffect(() => {
    GetAllBusinessTypeService();
    return(()=>{
      clearFilterHanlder();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    callGetStoreManagementListService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callGetStoreManagementListService]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "language" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetStoreManagementListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: storeList?.PagingDetails?.TotalPages,
      isPagerChange: false,
      isRefreshPage: false
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStoreManagement]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetStoreManagementListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateStoreManagementState.success) {
      resetAddUpdateStoreManagementState();
      callGetStoreManagementListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateStoreManagementState.success]);

  // useEffect(() => {
  //   setStoreFilterDetail({
  //     ...getStoreFilter,
  //     IsInvalid: showInvalidStores,
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [showInvalidStores]);

  useEffect(() => {
    if (userTypeEnum[userTypeEnum.SuperAdmin] === userType) {
      if (
        Number(businessTypeSearch) === -1 &&
        !showInvalidStores &&
        prefectureNameSearch === "" &&
        storeNameSearch === ""
      ) {
        resetStoreFilterDetail();
        setStoreNameSearch("");
        setSearchText("");
        setShowInvalidStores(false);
        setPrefectureNameSearch("");
        setPrefectureSearch("");
        setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
      }
    } else {
      if (
        !showInvalidStores &&
        prefectureNameSearch === "" &&
        storeNameSearch === ""
      ) {
        setStoreFilterDetail({
          IsFilterActive: false,
          IsInvalid: false,
          PrefectureName: "",
          BusinessTypeId: businessTypeSearch,
          StoreName: "",
        });
        setStoreNameSearch("");
        setSearchText("");
        setShowInvalidStores(false);
        setPrefectureNameSearch("");
        setPrefectureSearch("");
        setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
      }
    }
  }, [
    businessTypeSearch,
    prefectureNameSearch,
    resetStoreFilterDetail,
    setStoreFilterDetail,
    showInvalidStores,
    storeNameSearch,
    userType,
  ]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteStoreManagementSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteStoreManagementState.success) {
      resetDeleteStoreManagement();
      if (allStoreManagement?.length == 1) {
        if (pageInfo.currentPage > 1)
          setPageInfo({
            ...pageInfo,
            currentPage: 1,
            isRefreshPage: true,
            isPagerChange: true,
          });
        else callGetStoreManagementListService();
      } else callGetStoreManagementListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStoreManagementState.success]);

  /**
   * This function shows the add user pop up from where we can add new user and update existing user. we use id to identify
   * that we are adding or updating user.
   * "Id == -1" : we are adding new user
   * "Id != -1" : means we are updating existing user
   */
  const openAddStoreManagementHandler = (row: { Id: number }) => {
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetStoreManagementListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * This function provides manual refresh functionality
   */
  const refreshClickHandler = () => {
    callGetStoreManagementListService();
  };
  const history = useHistory();

  const openShiftManagement = (row: { Id: number }) => {
    history.push(`${RoutesConstants.ShiftManagement}`, { StoreId: row.Id });
  };

  const openReservation = (row: { Id: number }) => {
    history.push({
      pathname: RoutesConstants.ReservationSettings,
      state: { storeId: row.Id },
    });
  };

  const onSubmitForm = (values: IUpdateStorePassword) => {
    let submitData: IUpdateStorePassword;
    submitData = {
      // StoreId: props.id,
      // StoreCode: props.storeCode,
      StoreId: selectedId,
      StoreCode: selectedStoreCode,
      NewPassword: safeBase64Encode(values.NewPassword),
    };
    UpdatePasswordService(submitData);
  };

  const clearFilterHanlder = () => {
    resetStoreFilterDetail();
    setStoreNameSearch("");
    setSearchText("");
    setShowInvalidStores(false);
    setPrefectureNameSearch("");
    setBusinessTypeSearch(-1);
    setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
  }

  const changePasswordClickHandler = (row: {
    Id: number;
    StoreCode: string;
  }) => {
    setSelectedId(row.Id);
    setSelectedStoreCode(row.StoreCode);
    props.changePasswordToggleHandler();
  };

  const handleSearch = () => {
    if (userType !== userTypeEnum[userTypeEnum.HeadQuarter]) {
      resetStoreFilterDetail();
      setBusinessTypeSearch(storeInitialFilterState.BusinessTypeId ?? -1);
    }
    setPrefectureNameSearch(storeInitialFilterState.PrefectureName ?? "");
    setShowInvalidStores(storeInitialFilterState.IsInvalid ?? false);
    setSearchText(storeNameSearch);

    if (storeNameSearch.length > 0) {
      setStoreFilterDetail({
        ...getStoreFilter,
        IsFilterActive: true,
        StoreName: storeNameSearch,
      });
    }
    setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
  };

  const handlePrefectureSearch = () => {
    setSearchText("");
    setStoreNameSearch("");
    if (prefectureNameSearch.length > 0) {
      setStoreFilterDetail({
        ...getStoreFilter,
        IsFilterActive: true,
        IsInvalid: showInvalidStores,
        PrefectureName: prefectureNameSearch,
      });
      setPrefectureSearch(prefectureNameSearch);
    }
    setPageInfo({...pageInfo, currentPage: 1, isRefreshPage: true});
  };

  const columArray: any = [
    {
      columnType: ColumnType.Hidden,
      accessorKey: "Id",
    },
    {
      columnType: ColumnType.JsxElement,
      jsxElementFormatter: (info: CellContext<any, any>) => {
        const row = info.row.original;
        return (
          <>
            <img
              className="grid-img"
              src={row.Image ? row.Image : NoImage}
              alt="store img"
            />
          </>
        );
      },
      accessorKey: "Image",
      displayName: "",
      headerClassName: "img-column",
    },
    {
      columnType: ColumnType.JsxElement,
      jsxElementFormatter: (info: CellContext<any, any>) => {
        const row = info.row.original;
        return (
          <>
            <p>{row.StoreName}</p>
            <small className="text-muted">{row.StoreOwnerName}</small>
          </>
        );
      },
      accessorKey: "StoreName",
      displayName: "store_name",
      sortingName: "store_name",
    },
    {
      columnType: ColumnType.Sorting,
      accessorKey: "KanaName",
      displayName: "store_name_kana",
      sortingName: "kana_name",
    },
    {
      columnType: ColumnType.Sorting,
      accessorKey: "PrefectureName",
      sortingName: "prefecture_name",
      displayName: "prefecture_name",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "MobileNumber",
      displayName: "contact_number",
    },
    {
      columnType: ColumnType.JsxElement,
      jsxElementFormatter: (info: CellContext<any, any>) => {
        const row = info.row.original;
        return (
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              openAddStoreManagementHandler(row);
            }}
          >
            <i className="bi bi-eye me-2"></i>
            <FormattedMessage id="see_details" />
          </Button>
        );
      },
      accessorKey: "isEdit",
      displayName: "",
      headerClassName: "last-column",
    },
    {
      columnType: ColumnType.JsxElement,
      jsxElementFormatter: (info: CellContext<any, any>) => {
        const row = info.row.original;
        return (
          <>
            {isOperationPermittedRoleBase(
              ModuleType.StoreManagement,
              ActionType.Edit
            ) && (
              <Button
                className="me-2"
                variant="secondary"
                size="sm"
                onClick={() => {
                  changePasswordClickHandler(row);
                }}
                title={formatMessage("change_password")}
              >
                <i className="bi bi-lock"></i>
                {/* <FormattedMessage id="see_details" /> */}
              </Button>
            )}
            {findRouteAccess(ModuleType.ReservationSetting) &&
              userType === userTypeEnum[userTypeEnum.Store] && (
                <Button
                  variant="dark"
                  size="sm"
                  className="me-2 "
                  onClick={() => {
                    openReservation(row);
                  }}
                  title={formatMessage("reservation_settings")}
                >
                  <i className="bi bi-calendar-week"></i>
                </Button>
              )}
            {findRouteAccess(ModuleType.ShiftManagement) && (
              <Button
                title={formatMessage("shift_management")}
                variant="info"
                size="sm"
                onClick={() => {
                  openShiftManagement(row);
                }}
              >
                <i className="bi bi-clock-history"></i>
              </Button>
            )}
          </>
        );
      },
      accessorKey: "isChangePassword",
      displayName: "",
      headerClassName: "last-column",
    },
  ];
  const columns = getColumns<IStoreManagementList, number>(
    columArray,
    sorting,
    handleSortingChange
  );

  return (
    <React.Fragment>
      {props.showAddPopup && (
        <AddStoreManagement
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showChangePasswordPopup && (
        <ChangePassword
          id={selectedId}
          storeCode={selectedStoreCode}
          submitHandler={onSubmitForm}
          modalClosed={props.changePasswordToggleHandler}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="store_information" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="master_management" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="store_information" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 p-0">
        <div className="row g-2 align-items-center mb-3">
          <div className="col-lg-8 col-md-12 col-12 search_box">
            <div className="row g-2">
              <div className="col-md-4 col-6 ">
                <div className="input-group">
                  <div className="input-group-text">
                    <span role="button" onClick={handleSearch}>
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={formatMessage("search_by_free_word")}
                    value={storeNameSearch}
                    onChange={handleStoreNameSearch}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4 col-6">
                <div className="input-group">
                  <div className="input-group-text">
                    <span role="button" onClick={handlePrefectureSearch}>
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={formatMessage("search_by_prefecture")}
                    value={prefectureNameSearch}
                    onChange={handlePrefectureNameSearch}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handlePrefectureSearch();
                      }
                    }}
                  />
                </div>
              </div>
              {userType !== userTypeEnum[userTypeEnum.HeadQuarter] && (
                <div className="col-md-4 col-12">
                  <div className="input-group">
                    <div className="input-group-text">
                      <span role="button" onClick={() => {}}>
                        <FontAwesomeIcon icon={faSearch} />
                      </span>
                    </div>
                    <DropdownInput
                      className="form-control"
                      placeholder={formatMessage("search_by_business_type")}
                      value={businessTypeSearch}
                      disabled={
                        userType === userTypeEnum[userTypeEnum.HeadQuarter]
                      }
                      onChange={handleBusinessTypeSearch}
                      options={getAllBusinessTypesAll.map((option) => ({
                        label: option.value,
                        value: option.id,
                      }))}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-4 col-md-12 col-12">
            <div className="d-flex gap-2 justify-content-end align-items-center flex-wrap">
              <input
                type="checkbox"
                className="form-check-input m-0"
                checked={showInvalidStores}
                onChange={handleInvalidStaffFilter}
              />
              <label className="form-check-label ms-1">
                {formatMessage("show_invalid_stores")}
              </label>
              {getStoreFilter.IsFilterActive && (
                <button
                  className={`ms-3 btn ${
                    getStoreFilter.IsFilterActive
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={clearFilterHanlder}
                  title={formatMessage(
                    getStoreFilter.IsFilterActive
                      ? "clear_filter"
                      : "apply_filter"
                  )}
                >
                  <svg
                    id="fi_3126668"
                    enableBackground="new 0 0 512 512"
                    height="18"
                    viewBox="0 0 512 512"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#ffffff"
                  >
                    <g>
                      <path d="m215.546 85.327h-162.264c-18.073 0-28.679 20.379-18.31 35.187.133.199-3.448-4.682 130.024 177.006 5.921 8.587 4.149-.599 4.149 190.987 0 19.245 21.993 30.358 37.542 18.791 57.536-43.372 71.516-48.257 71.516-70.955 0-133.909-1.721-130.311 4.149-138.823l27.851-37.923c-70.082-25.496-112.087-99.608-94.657-174.27z"></path>
                      <path d="m281.951 30.166c-75.076 67.31-38.685 187.35 55.962 206.05 75.479 15.948 143.193-43.867 143.193-116.945 0-102.594-122.364-157.159-199.155-89.105zm118.529 106.804c9.515 9.466 2.715 25.676-10.603 25.676-8.014 0-10.022-3.79-28.462-22.158-18.064 17.984-20.27 22.158-28.472 22.158-13.349 0-20.063-16.264-10.603-25.676l17.769-17.699-17.769-17.699c-14.107-14.035 7.142-35.322 21.216-21.297l17.859 17.779 17.849-17.779c14.074-14.025 35.331 7.254 21.216 21.297l-17.769 17.699z"></path>
                    </g>
                  </svg>
                </button>
              )}
              {isOperationPermittedRoleBase(
                ModuleType.StoreManagement,
                ActionType.Add
              ) && (
                <button
                  className="btn btn-primary ms-3"
                  onClick={() => {
                    openAddStoreManagementHandler({ Id: -1 });
                  }}
                >
                  <i className="bi bi-plus-lg me-1"></i>
                  {formatMessage("add_store")}
                </button>
              )}
            </div>
          </div>
        </div>
        {allStoreManagement.length > 0 ? (
          <div className={`${openPanel ? "panelOpen" : ""}`}>
            <div>
              <div className="card changingPanel">
                <div className="tableDesign row-eq-height tableDevices">
                  <div
                    className="table-responsive storeListTable"
                    data-testid="table"
                  >
                    {allStoreManagement && (
                      <Grid
                        data={allStoreManagement}
                        columns={columns}
                        isInProgress={inProgress}
                        hiddenColumns={["Id"]}
                      />
                    )}
                    {(inProgress || masterManagementStore.inProgress) && (
                      <FormLoader
                        loading={inProgress || masterManagementStore.inProgress}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allStoreManagement.length > 0 ? (
                <div className="d-flex align-items-center justify-content-center p-2 tableFooter">
                  <Pagination
                    isRefreshPage={pageInfo.isRefreshPage}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />

                  <select
                    data-testid="pageSelect"
                    className="pageLimit ms-1"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op) => (
                      <option key={op} value={op}>
                        {op} {formatMessage("rows")}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="message text-center">
            <img src={noMessageIcon} alt="" className="no_message" />
            {searchText.trim().length > 0 ||
            storeNameSearch.trim().length > 0 ||
            prefectureNameSearch.trim().length > 0 ||
            businessTypeSearch !== 0 ||
            showInvalidStores ? (
              <>
                <p className="noData text-muted text-center h4 mb-0">
                  <FormattedMessage id="no_data_available" />
                </p>
              </>
            ) : (
              <>
                <p className="noData text-muted text-center h4 mb-0">
                  <FormattedMessage id="no_store" />
                </p>
                <p className="mb-3">{formatMessage("no_store_message")}</p>
                {isOperationPermittedRoleBase(
                  ModuleType.StoreManagement,
                  ActionType.Add
                ) && (
                  <LoaderButton
                    text="add_store"
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
                      openAddStoreManagementHandler({ Id: -1 })
                    }
                  />
                )}
              </>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ChangePasswordPopupHOC(
  AddPopupHOC(ShowPopupHOC(DeletePopupHOC(observer(StoreList))))
);
